{
  "requirements": [
    {
      "plan": "Mais",
      "group": ["Grupo 0", "Grupo 1"],
      "time": ["24 (vinte e quatro) horas", "180 (cento e oitenta) dias"],
      "procedures": [
        "Urgência, Diagnóstico, Radiologia, Odontopediatria, Prevenção em Saúde Bucal, Periodontia, Dentística, Endodontia e Cirurgia.",
        "Prótese do Rol da ANS e Disfunção Têmporo Mandibular (DTM)."
      ]
    },
    {
      "plan": "Mais Doc",
      "group": ["Grupo 0", "Grupo 1", "Grupo 2"],
      "time": [
        "24 (vinte e quatro) horas",
        "90 (noventa) dias",
        "180 (cento e oitenta) dias"
      ],
      "procedures": [
        "Urgência, Diagnóstico, Radiologia, Odontopediatria, Prevenção em Saúde Bucal, Periodontia, Dentística, Endodontia e Cirurgia.",
        "Documentação Ortodôntica (Ortodontia).",
        "Prótese do Rol da ANS e Disfunção Têmporo Mandibular (DTM)."
      ]
    },
    {
      "plan": "Mais Clarear",
      "group": ["Grupo 0", "Grupo 1", "Grupo 2"],
      "time": [
        "24 (vinte e quatro) horas",
        "90 (noventa) dias",
        "180 (cento e oitenta) dias"
      ],
      "procedures": [
        "Urgência, Diagnóstico, Radiologia, Odontopediatria, Prevenção em Saúde Bucal, Periodontia, Dentística, Endodontia, Cirurgia e Prótese do Rol da ANS.",
        "Clareamento Dentário Caseiro Gel e Moldeira (Estética).",
        "Disfunção Têmporo Mandibular (DTM)."
      ]
    },
    {
      "plan": "Mais Orto",
      "group": ["Grupo 0", "Grupo 1", "Grupo 2"],
      "time": [
        "24 (vinte e quatro) horas",
        "90 (noventa) dias",
        "180 (cento e oitenta) dias"
      ],
      "procedures": [
        "Urgência, Diagnóstico, Radiologia, Odontopediatria, Prevenção em Saúde Bucal, Periodontia, Dentística, Endodontia, Cirurgia e Prótese do Rol da ANS.",
        "Ortodontia e Documentação Ortodôntica (Ortodontia).",
        "Disfunção Têmporo Mandibular (DTM)."
      ]
    },
    {
      "plan": "Mais Pro",
      "group": ["Grupo 0", "Grupo 1"],
      "time": ["24 (vinte e quatro) horas", "180 (cento e oitenta) dias"],
      "procedures": [
        "Urgência, Diagnóstico, Radiologia, Odontopediatria, Prevenção em Saúde Bucal, Periodontia, Dentística, Endodontia, Cirurgia e Prótese do Rol da ANS.",
        "Próteses Extra Rol da ANS e Disfunção Têmporo Mandibular (DTM)."
      ]
    },
    {
      "plan": "Mais Amplo",
      "group": ["Grupo 0", "Grupo 1", "Grupo 2"],
      "time": [
        "24 (vinte e quatro) horas",
        "90 (noventa) dias",
        "180 (cento e oitenta) dias"
      ],
      "procedures": [
        "Urgência, Diagnóstico, Radiologia, Odontopediatria, Prevenção em Saúde Bucal, Periodontia, Dentística, Endodontia, Cirurgia e Prótese do Rol da ANS.",
        "Clareamento Dentário Caseiro Gel e Moldeira (Estética), Ortodontia e Documentação Ortodôntica (Ortodontia).",
        "Próteses Extra Rol da ANS e Disfunção Têmporo Mandibular (DTM)."
      ]
    }
  ]
}
